import { IndicatorTableEditor } from './table-editor'
export { default as DataDuplicator } from './data-duplicator'


export default IndicatorTableEditor